/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 照片水印筛选状态管理
 * @LastEditors: refactor
 * @LastEditTime: 2026-03-24
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import dayjs from 'dayjs'

// Filter 类型
interface PhotoWatermarkFilter {
  keyword: string
  mediaType: number
  times: [any, any]
  departmentUsers: any[]
  departments: any[]
  watermarks: any[]
  existPhotoComment: string
  labelIDs?: string[]
  labelMatchAll?: boolean
}

// State 类型
interface PhotoWatermarkState {
  filter: PhotoWatermarkFilter
  queryFilter: PhotoWatermarkFilter | null
  photosWatermarksTotalPhotos: number
  triggerPhotoWaterMarkExcel: boolean
  aiRecognitionResults: any[]
  membersCheckedList?: any[]
}

const initialFilter: PhotoWatermarkFilter = {
  keyword: '',
  mediaType: -1,
  times: [dayjs().startOf('month'), dayjs().endOf('day')],
  departmentUsers: [],
  departments: [],
  watermarks: [],
  existPhotoComment: '0',
  labelIDs: [],
  labelMatchAll: false
}

const initialState: PhotoWatermarkState = {
  filter: initialFilter,
  queryFilter: null,
  photosWatermarksTotalPhotos: 0,
  triggerPhotoWaterMarkExcel: false,
  aiRecognitionResults: []
}

const photoWatermarkSlice = createSlice({
  name: 'photoWatermark',
  initialState,
  reducers: {
    setExportWatermarkFilter: (
      state,
      action: PayloadAction<PhotoWatermarkFilter>
    ) => {
      state.filter = action.payload
    },

    resetExportWatermarkFilter: (state) => {
      state.filter = initialFilter
      state.queryFilter = initialFilter
    },

    setPhotoWatermarkQueryFilter: (
      state,
      action: PayloadAction<PhotoWatermarkFilter>
    ) => {
      state.queryFilter = action.payload
    },

    setPhotosWatermarksTotalPhotos: (state, action: PayloadAction<number>) => {
      state.photosWatermarksTotalPhotos = action.payload
    },

    triggerPhotoWaterMarkExcel: (state, action: PayloadAction<boolean>) => {
      state.triggerPhotoWaterMarkExcel = action.payload
    },

    setAiRecognitionResults: (state, action: PayloadAction<any[]>) => {
      state.aiRecognitionResults = action.payload
    }
  },
  extraReducers: (builder) => {
    // 兼容旧的 dispatch({ type: actionTypes.XXX, data: ... }) 调用
    builder
      .addMatcher(
        (action) => action.type === 'SET_PHOTOS_WATERMARKS_TOTAL_PHOTOS',
        (state, action: any) => {
          state.photosWatermarksTotalPhotos = action.data
        }
      )
      .addMatcher(
        (action) => action.type === 'TRIGGER_PHOTO_WATERMARK_EXCEL',
        (state, action: any) => {
          state.triggerPhotoWaterMarkExcel = action.data
        }
      )
  }
})

export const {
  setExportWatermarkFilter,
  resetExportWatermarkFilter,
  setPhotoWatermarkQueryFilter,
  setPhotosWatermarksTotalPhotos,
  triggerPhotoWaterMarkExcel,
  setAiRecognitionResults
} = photoWatermarkSlice.actions

export default photoWatermarkSlice.reducer
